/* VEYRISSA MOTION V2 — runtime-cleaned local interaction choreography. */
(function(){
  'use strict';

  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var timers=new WeakMap();

  function restartClass(node,name,duration){
    if(!node||reduce)return;
    node.classList.remove(name);
    void node.offsetWidth;
    node.classList.add(name);
    var old=timers.get(node);
    if(old)window.clearTimeout(old);
    timers.set(node,window.setTimeout(function(){
      node.classList.remove(name);
      timers.delete(node);
    },duration||240));
  }

  document.documentElement.classList.remove('veyrissa-page-enter');
  window.addEventListener('pageshow',function(){
    document.documentElement.classList.remove('veyrissa-page-enter');
  });

  document.addEventListener('click',function(event){
    var variant=event.target.closest&&event.target.closest('.veyrissa-variant-option,.veyrissa-segment-option');
    if(variant)restartClass(variant,'is-motion-selected',230);
  },true);

  document.addEventListener('change',function(event){
    var input=event.target.closest&&event.target.closest('.product__quantity-stepper input[name="quantity"]');
    if(input)restartClass(input,'is-motion-bump',200);
  },true);

  function watchCart(){
    var drawer=document.getElementById('CartDrawer');
    if(!drawer||drawer.dataset.motionV2Ready==='true')return;
    drawer.dataset.motionV2Ready='true';
    var observer=new MutationObserver(function(records){
      if(!drawer.classList.contains('is-open'))return;
      var meaningful=records.some(function(record){
        return record.type==='childList'&&(record.addedNodes.length||record.removedNodes.length);
      });
      if(!meaningful)return;
      var panel=drawer.querySelector('.drawer__panel');
      if(panel)restartClass(panel,'is-motion-refreshing',220);
    });
    observer.observe(drawer,{childList:true,subtree:true});
  }

  watchCart();
  document.addEventListener('shopify:section:load',watchCart);
})();